<div class="article-select-container">
  <div *ngIf="currentView === 'categories'">
    <ion-list data-cy="Categories list">
      <ion-item
        *ngFor="let category of categories"
        [button]="true"
        (click)="selectCategory(category)"
        class="reduced"
        detail="false"
        data-cy="Macro voice item"
      >
        <ng-container *ngIf="categoryTemplate; else defaultCategoryTemplate">
          <ng-container *ngTemplateOutlet="categoryTemplate; context: { $implicit: category }"></ng-container>
        </ng-container>

        <ng-template #defaultCategoryTemplate>
          <span class="ion-text-left truncate-text">{{ category.name }}</span>
          <div class="item-end-wrapper">
            <ng-container *ngIf="category.items?.length as itemCount">
              <span class="item-count">
                {{ 'pages.article-select-list.items' | translate: { count: itemCount } }}
              </span>
            </ng-container>
            <ion-icon size="small" name="chevron-forward-outline"></ion-icon>
          </div>
        </ng-template>
      </ion-item>
    </ion-list>
  </div>

  <div *ngIf="currentView === 'items'">
    <ion-item-divider class="section-header">
      <ion-label class="font-medium">{{ selectedCategory?.name }}</ion-label>
    </ion-item-divider>

    <ion-list data-cy="Items list">
      <ion-item *ngFor="let item of currentItems" [button]="true" (click)="selectItem(item)" class="reduced" data-cy="Budget item">
        <ng-container *ngIf="itemTemplate; else defaultItemTemplate">
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        </ng-container>

        <ng-template #defaultItemTemplate>
          <span class="ion-text-left truncate-text">{{ item.name }}</span>
          <div class="item-end-wrapper">
            <ng-container *ngIf="item.articles?.length as artCount">
              <span class="item-count">
                {{ 'pages.article-select-list.article' | translate: { count: artCount } }}
              </span>
            </ng-container>
            <ng-container *ngIf="!item.articles?.length && item.itemCount as count">
              <span class="item-count">
                {{ 'pages.article-select-list.article' | translate: { count: count } }}
              </span>
            </ng-container>
            <ion-icon size="small" name="chevron-forward-outline"></ion-icon>
          </div>
        </ng-template>
      </ion-item>
    </ion-list>
  </div>

  <div *ngIf="currentView === 'articles'">
    <div
      *ngIf="showFilters && filtersConfig.length > 0"
      class="filters-container ion-flex ion-justify-content-between ion-align-items-center ion-padding"
      data-cy="Budget item filters"
    >
      <span class="label-min-content">{{ 'pages.article-select-list.filter-title' | translate }}</span>
      <div data-cy="Filter buttons">
        <ng-container *ngFor="let filter of filtersConfig">
          <ion-button size="small" [color]="filterProperty === filter.key ? 'primary' : 'inactive'" (click)="filterFor(filter.key)">
            {{ filter.label | translate }}
          </ion-button>
        </ng-container>
      </div>
    </div>

    <ion-item-divider class="section-header">
      <ion-label class="font-medium">{{ selectedItem?.name }}</ion-label>
    </ion-item-divider>

    <ion-list data-cy="Articles list">
      <ion-item
        *ngFor="let article of currentArticles"
        [button]="true"
        (click)="selectArticle(article)"
        class="reduced"
        data-cy="Checkbox item"
      >
        <ng-container *ngIf="articleTemplate; else defaultArticleTemplate">
          <ng-container
            *ngTemplateOutlet="articleTemplate; context: { $implicit: article, selected: isArticleSelected(article) }"
          ></ng-container>
        </ng-container>

        <ng-template #defaultArticleTemplate>
          <ion-icon name="pricetag" class="item-icon"></ion-icon>
          <span class="ion-text-left truncate-text font-medium">{{ article.name }}</span>
          <div class="item-end-wrapper">
            <span class="amount" *ngIf="showAmounts" data-cy="Budget item amount">{{
              getBudgetAmount() | fixBackendPrice | currency: 'EUR'
            }}</span>
            <ion-icon *ngIf="isArticleSelected(article)" name="checkmark-circle" color="success"></ion-icon>
            <ion-icon *ngIf="!isArticleSelected(article)" name="ellipse-outline" color="medium"></ion-icon>
          </div>
        </ng-template>
      </ion-item>
    </ion-list>
  </div>
</div>
